/**
 * Loan Validation Schemas
 * Yup validation schemas for loan forms
 */
import * as yup from 'yup';

export const loanSchema = yup.object({
  memberId: yup.string().required('Member ID is required'),
  loanType: yup
    .string()
    .oneOf(['personal', 'business', 'emergency', 'education', 'asset'], 'Invalid loan type')
    .required('Loan type is required'),
  amount: yup
    .number()
    .min(100000, 'Minimum loan amount is TSh 100,000')
    .max(50000000, 'Maximum loan amount is TSh 50,000,000')
    .required('Loan amount is required'),
  interestRate: yup
    .number()
    .min(1, 'Interest rate must be at least 1%')
    .max(25, 'Interest rate must be at most 25%')
    .required('Interest rate is required'),
  termMonths: yup
    .number()
    .min(1, 'Term must be at least 1 month')
    .max(60, 'Term must be at most 60 months')
    .required('Term is required'),
  purpose: yup.string().max(500, 'Purpose is too long'),
});

export default { loanSchema };
